import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './Navigation.css';

function Navigation() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <nav className="navbar">
      <div className="nav-container">
        <Link to="/" className="nav-logo">
          Salt Delivery
        </Link>

        <ul className="nav-menu">
          {user && (
            <li className="nav-item">
              <Link to="/products" className="nav-link">
                Products
              </Link>
            </li>
          )}

          {user && user.role === 'admin' && (
            <li className="nav-item">
              <Link to="/admin/products" className="nav-link">
                Manage Products
              </Link>
            </li>
          )}

          {user ? (
            <>
              {user.role === 'customer' && (
                <>
                  <li className="nav-item">
                    <Link to="/dashboard" className="nav-link">
                      Dashboard
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/orders" className="nav-link">
                      Orders
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/subscriptions" className="nav-link">
                      Subscriptions
                    </Link>
                  </li>
                </>
              )}

              {user.role === 'driver' && (
                <>
                  <li className="nav-item">
                    <Link to="/driver" className="nav-link">
                      My Deliveries
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/admin/pickup-events" className="nav-link">
                      Pickup Events
                    </Link>
                  </li>
                </>
              )}

              {user.role === 'admin' && (
                <>
                  <li className="nav-item">
                    <Link to="/admin" className="nav-link">
                      Admin Dashboard
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/admin/pickup-events" className="nav-link">
                      Pickup Events
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/admin/drivers" className="nav-link">
                      Manage Drivers
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/orders" className="nav-link">
                      All Orders
                    </Link>
                  </li>
                </>
              )}

              <li className="nav-item">
                <Link to="/profile" className="nav-link">
                  Profile
                </Link>
              </li>

              <li className="nav-item">
                <button onClick={handleLogout} className="nav-link btn-logout">
                  Logout
                </button>
              </li>

              <li className="nav-item nav-user">
                {user.first_name} ({user.role})
              </li>
            </>
          ) : (
            <>
              <li className="nav-item">
                <Link to="/login" className="nav-link">
                  Login
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/register" className="nav-link">
                  Register
                </Link>
              </li>
            </>
          )}
        </ul>
      </div>
    </nav>
  );
}

export default Navigation;
